import request from "../utils/request";

export function getSelfServiceSessionEvents(params) {
  return request.get("SelfService/session-events", { params });
}

/** Kasa teşhis günlüğü — yalnızca süper admin (backend [SuperAdmin]). */
export function getSelfServiceDiagnosticEvents(params) {
  return request.get("SelfService/session-events/diagnostics", { params });
}

export function getSelfServiceSessionEventsExcel(params) {
  return request.get("SelfService/session-events/excel", {
    responseType: "blob",
    params
  });
}
